/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMathYPlusY = createReactComponent("math-y-plus-y", "IconMathYPlusY", [
  ["path", { d: "M2 9l3 5.063", key: "svg-0" }],
  ["path", { d: "M8 9l-4.8 9", key: "svg-1" }],
  ["path", { d: "M16 9l3 5.063", key: "svg-2" }],
  ["path", { d: "M22 9l-4.8 9", key: "svg-3" }],
  ["path", { d: "M10 12h4", key: "svg-4" }],
  ["path", { d: "M12 10v4", key: "svg-5" }]
]);

export { IconMathYPlusY as default };
//# sourceMappingURL=IconMathYPlusY.js.map
